import React from "react";
import {Menu, Box, MenuItem} from "@material-ui/core";
import { PersonOutlineOutlined, ExitToAppOutlined } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import LoadingWidget from "../../widgets/LoadingWidget";
import { get } from "lodash";
import { useStyles } from "./styles";

const ProfileMenu = props => {
  const classes = useStyles();
  const isMenuOpen = Boolean(props.anchorEl);
  const { t } = useTranslation();
  // containerRef used to unblock scroll issue
  const containerRef = React.useRef();
  return (
    <div ref={containerRef}>
      <Menu
        container={containerRef.current}
        anchorEl={props.anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        id={props.menuId}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={props.handleMenuClose}
      >
        {props.isCompanySetupCompleted && (
          <MenuItem onClick={props.handleProfile}>
            <PersonOutlineOutlined className={classes.profileMenuIcon} />
            {t("layout.myProfile")}
          </MenuItem>
        )}
        <MenuItem onClick={props.handleLogout}>
          {get(props, "logOutLoading", false) ? (
            <Box textAlign="center" width="100%">
            <LoadingWidget color="grey" />
          </Box>
          ) : (
            <>
              <ExitToAppOutlined className={classes.profileMenuIcon} />
              {t("layout.logout")}
            </>
          )}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
